<template>
  <div>
    <el-card>
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-row :gutter="10">
              <el-col :span="12">
                <!--包裹号-->
                <el-form-item :label="$t('mdfeTranslate.PackageNumber')">
                  <el-input
                    v-model="queryForm.params.packageNumbers"
                    :placeholder="$t('collectionCenter.max2000Line')"
                    type="textarea"
                    :rows="5"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--业务单号-->
                <el-form-item :label="$t('receivablePayable.TicketNumber')">
                  <el-input
                    v-model="queryForm.params.waybillNumbers"
                    :placeholder="$t('collectionCenter.max2000Line')"
                    type="textarea"
                    :rows="5"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <!-- 开票时间 -->
            <el-form-item :label="$t('GlobalSetObj.UpdateTime')">
              <el-date-picker
                v-model="queryForm.params.invoiceIssueTime"
                type="datetimerange"
                range-separator="-"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--业务类型-->
            <el-form-item :label="$t('collectionCenter.businessT')">
              <el-select
                v-model="queryForm.params.businessType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%;"
              >
                <el-option key="0" :label="$t('collectionCenter.expressDelivery')" :value="0" />
                <el-option key="1" :label="$t('collectionCenter.lanshou')" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--  客户  -->
            <el-form-item :label="$t('GlobalSetObj.client')">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                collapse-tags
                style="width: 100%"
                @visible-change="getCustomerPage()"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin-top: 28px;">
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="getTable"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="mini"
                @click="onReset"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <!--重新生成-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:cte-rebuildCreate'"
          type="primary"
          size="mini"
          @click="bulkRebuildCreate()"
        >{{ $t('GlobalSetObj.Rebuild') }}
        </el-button>
        <!--批量导出-->
        <el-button
          v-permit:remove="'btn:invoiceCenter:cte-bulkExport'"
          type="primary"
          size="mini"
          @click="bulkExport()"
        >{{ $t('collectionCenter.export') }}
        </el-button>
      </div>
      <el-table
        ref="tableListRef"
        :data="tableData"
        border
        class="table-height"
        row-key="id"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <!-- 业务单号 -->
        <el-table-column prop="waybillNumber" :label="$t('receivablePayable.TicketNumber')" min-width="200" />
        <!-- 包裹号 -->
        <el-table-column prop="packageNumber" :label="$t('mdfeTranslate.PackageNumber')" min-width="200" />
        <!-- 业务类型 -->
        <el-table-column prop="businessType" :label="$t('collectionCenter.businessT')" min-width="160">
          <template #default="scope">
            <span v-if="scope.row.businessType === 0">{{ $t('collectionCenter.expressDelivery') }}</span>
            <span v-else>{{ $t('collectionCenter.lanshou') }}</span>
          </template>
        </el-table-column>
        <!-- 消息体 -->
        <el-table-column
          prop="msgBody"
          :label="$t('mdfeTranslate.MessageBody')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template #default="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.msgBody }}
              </pre>
              <div class="paramsStyle">{{ scope.row.msgBody }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 失败原因 -->
        <el-table-column prop="failedReason" :label="$t('GlobalSetObj.ReasonForFailure')" min-width="200" />
        <!-- 创建时间 -->
        <el-table-column prop="createTime" :label="$t('GlobalSetObj.CreationTime')" min-width="180" />
        <!--更新时间-->
        <el-table-column prop="updateTime" :label="$t('GlobalSetObj.UpdateTime')" min-width="180" />
        <!--操作-->
        <el-table-column
          :label="$t('GlobalSetObj.operate')"
          fixed="right"
          width="130"
          align="center"
        >
          <template #default="scope">
            <el-button
              v-permit:remove="'btn:invoiceCenter:cte-rebuildCreate'"
              type="primary"
              size="mini"
              @click="rebuildCreate(scope.row)"
            >{{ $t('GlobalSetObj.Rebuild') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
    <el-dialog
      :title="$t('GlobalSetObj.Rebuild')"
      :visible.sync="showBulkExportWindow"
      width="600px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="closeBulkExport"
    >
      <div>
        <div style="margin-bottom: 20px;">
          <el-radio-group v-model="businessType">
            <el-radio-button :label="0">{{ $t('collectionCenter.expressDelivery') }}</el-radio-button>
            <el-radio-button :label="1">{{ $t('collectionCenter.lanshou') }}</el-radio-button>
          </el-radio-group>
        </div>
        <span>{{ $t('orderCenterCont.DownloadTemplate') }}：</span>
        <div ref="download1" style="display: inline-block;margin-bottom: 10px;">
          <span style="cursor: pointer" @click="initDown()">
            <span style="color:#00A551;">批量重新生成模板.xlsx</span>
            <span class="el-icon-download" style="color:#00A551;margin-left: 20px" />
          </span>
        </div>
        <div>
          <el-upload
            ref="demoUpload"
            :before-upload="beforeUpload"
            :file-list="orderNumber"
            :http-request="upLoad"
            :limit="1"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            action
            class="upload-demo"
            drag
            multiple
          >
            <i class="el-icon-plus" style="margin: 50px auto 20px;" />
            <!-- 点击或拖拽文件到此处上传 -->
            <div class="el-upload__text">{{ $t('orderImport.cldrUpload') }}</div>
            <!--请上传.txt格式文件-->
            <!--<div class="el-upload__text">{{ $t('spareNumberPoo.PleaseUploadTXT') }}</div>-->
            <div class="el-upload__text">{{ $t('orderCenterCont.OnlyExcelFilesCanBeUploaded') }}</div>
          </el-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showBulkExportWindow = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmBulkExport">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { batchReGenerate, exportNfseDataCheck, getCteAutoCreateFailPage, reGenerateCte } from '@/api/invoiceCenter';
import { apiCustomerPage } from '@/api/customer';
// import { getUserIdAndNameObj } from '@/enums/storageEnum';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'CteCreationFailed',
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          invoiceIssueTime: [startTime, endTime],
          waybillNumbers: '',
          packageNumbers: '',
          customerIds: [],
          businessType: null
        }
      },
      total: 0,
      tableData: [],
      pickerMinDate: '',
      pickerRange: 15 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      customerList: [],
      showBulkExportWindow: false,
      businessType: null,
      orderNumber: [],
      isUpload: false,
      upLoadFile: null,
      fileData: null
    };
  },
  created() {
    // this.userObj = getUserIdAndNameObj();
    this.getTable();
    this.getCustomerPage();
  },
  methods: {
    // 打开批量重新生成窗口
    bulkRebuildCreate() {
      this.showBulkExportWindow = true;
    },
    // 确认批量重新生成
    confirmBulkExport() {
      if (!this.isUpload) {
        this.$message.warning(this.$t('routes.pleaseUploadFile'));
        return;
      }
      if (this.businessType === null || this.businessType === '' || this.businessType === undefined) {
        this.$message.warning(this.$t('mdfeTranslate.PleaseSelectBusinessType'));
        return;
      }
      this.upLoadFile = new FormData();
      this.upLoadFile.append('file', this.fileData);
      this.upLoadFile.append('businessType', this.businessType);
      batchReGenerate(this.upLoadFile).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          this.showBulkExportWindow = false;
        }
      });
      console.log(this.upLoadFile);
    },
    // 关闭弹窗清除数据
    closeBulkExport() {
      this.orderNumber = [];
      this.businessType = null;
    },
    // 下载模板
    initDown() {
      const a = document.createElement('a');
      a.href = '/static/批量重新生成模板.xlsx';
      // console.log('文件地址——>', a.href);
      a.download = '批量重新生成模板';
      a.style.display = 'none';
      this.$nextTick(() => {
        this.$refs.download1.appendChild(a);
      });
      a.click();
      a.remove();
    },
    beforeUpload(file) {
      const { name } = file;
      const index = name.lastIndexOf('.');
      const ext = name.substr(index + 1);
      const typeFile = ['xlsx'];
      if (!typeFile.includes(ext)) {
        this.$message.warning(this.$t('orderCenterCont.OnlyExcelFilesCanBeUploaded')); // '只能上传Excel文件'
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        // 上传文件大小不能超过 2MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    upLoad(option) {
      console.log(option, 'optionoptionoption123465');
      // 导入xlsx模版
      const files = option.file;
      this.fileData = files;
      this.isUpload = true;
      this.orderNumber = [files];
    },
    handleRemove() {
      this.orderNumber = [];
      this.upLoadFile = {};
      this.isUpload = false;
      this.fileData = null;
    },
    handleExceed() {
      this.$message.error(this.$t('basicData.Only1FileCanBeUploadedAtATime'));
    },
    // 批量导出
    bulkExport() {
      const { waybillNumbers, packageNumbers, invoiceIssueTime } = this.queryForm.params;
      if (this.getValue(waybillNumbers).length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.getValue(packageNumbers).length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.getValue(waybillNumbers).length === 0 && this.getValue(packageNumbers).length === 0) {
        if (!invoiceIssueTime || invoiceIssueTime.length === 0) {
          this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      const param = this.getParams();
      exportNfseDataCheck(param).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 重新生成
    rebuildCreate(row) {
      this.$confirm(this.$t('mdfeTranslate.AreYouSureYouWantToRegenerate'), this.$t('GlobalSetObj.tips'), {
        confirmButtonText: this.$t('GlobalSetObj.confirm'),
        cancelButtonText: this.$t('GlobalSetObj.cancel'),
        type: 'warning'
      }).then(() => {
        reGenerateCte(row.id).then(() => {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          this.getTable();
        });
      }).catch(() => {});
    },
    // 单号整理
    getValue(number) {
      const arr = [];
      if (number.length) {
        const arrList = number.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
        arrList.map(item => {
          if (item && arr.includes(item) === false) {
            arr.push(item);
          }
        });
      }
      return arr;
    },
    // 查询参数整理
    getParams() {
      const { invoiceIssueTime, waybillNumbers, packageNumbers, businessType } = this.queryForm.params;
      const paramData = {
        updateStartTime: '',
        updateEndTime: '',
        customerIds: this.queryForm.params.customerIds || [],
        waybillNumbers: this.getValue(waybillNumbers),
        packageNumbers: this.getValue(packageNumbers),
        businessType
      };
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        paramData.updateStartTime = invoiceIssueTime[0];
        paramData.updateEndTime = invoiceIssueTime[1];
      }
      return paramData;
    },
    // 获取列表
    getTable() {
      const { invoiceIssueTime, waybillNumbers, packageNumbers } = this.queryForm.params;
      if (this.getValue(waybillNumbers).length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.getValue(packageNumbers).length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.getValue(waybillNumbers).length === 0 && this.getValue(packageNumbers).length === 0) {
        if (!invoiceIssueTime || invoiceIssueTime.length === 0) {
          this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      const param = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.getParams()
      };
      getCteAutoCreateFailPage(param).then(res => {
        res.data.records.map(item => {
          // if (item.updateUser) {
          //   item.createUserStr = this.userObj[item.updateUser] || '';
          // }
          if (item.msgBody) {
            item.msgBody = JSON.stringify(JSON.parse(item.msgBody), null, 2);
          }
        });
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 重置
    onReset() {
      this.queryForm.params.invoiceIssueTime = [startTime, endTime];
      this.queryForm.params.waybillNumbers = '';
      this.queryForm.params.packageNumbers = '';
      this.queryForm.params.businessType = null;
      this.queryForm.params.customerIds = [];
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.getTable();
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>
<style scoped>
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
